import Reinsurance from './Reinsurance';

export default Reinsurance;
